<template>
    <div id="batch-history">
        <div class="flex">
            <div class="pr-2 w-2/3 left-content">
                <div class="left-header flex align-center justify-between mb-4">
                    <div class="vx-breadcrumb">
                        <ul class="flex flex-wrap items-center">
                            <li class="inline-flex items-end">
                                <router-link to="/after-login"><feather-icon icon="HomeIcon" svgClasses="h-5 w-5 mb-1 mr-1 stroke-current text-primary" /></router-link>
                                <span class="breadcrumb-separator mx-2 mr-1"><feather-icon icon="ChevronsRightIcon" svgClasses="w-4 h-4" /></span>
                            </li>
                            <li class="inline-flex items-end">
                                <span class="breadcrumb-separator mx-2 mb-1 cur-breadcrumb-color">Batch History</span>
                            </li>
                        </ul>
                    </div>
                    <div class="flex-center date-filter">
                        <date-picker class="ml-5 filter-date-picker" v-model="date_filter" @change="getData" :format="date_format_string" range-separator="  to  " range type="date" :editable="false" :clearable="false" placeholder="From date to date"></date-picker>
                    </div>
                </div>

                <vs-table :data="batchHistory" :max-items="itemsPerPage" :class="{'no-pagination': totalPages <= 1 }">
                    <template slot="thead">
                        <vs-th class="center-title text-center">DATE</vs-th>
                        <vs-th class="center-title text-center">DISCOUNT</vs-th>
                        <vs-th class="center-title text-center">TIP</vs-th>
                        <vs-th class="center-title text-center">REDEEM</vs-th>
                        <vs-th class="center-title text-center">INCOME</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr :data="item" v-for="(item, index) in data" :key="index" class="shadow-md" :class="{ 'active' : activeItem && activeItem.date == item.date }" @click.native="setActiveItem(item)">
                            <vs-td class="text-center">{{ item.display_date }}</vs-td>
                            <vs-td class="text-center">${{ formatAmountNum(item.discount) }}</vs-td>
                            <vs-td class="text-center">${{ formatAmountNum(item.tip) }}</vs-td>
                            <vs-td class="text-center">${{ formatAmountNum(item.redeem) }}</vs-td>
                            <!-- <vs-td class="text-center">${{ formatAmountNum(item.income + item.tip + item.tax - item.cash_discount) }}</vs-td> -->
                            <vs-td class="text-center">${{ formatAmountNum(item.total) }}</vs-td>
                        </vs-tr>
                    </template>
                </vs-table>

                <custom-pagination class="custom-pagination" :totalPages="totalPages" :currentPage="currentPage" style="transform: translateY(15px);" v-if="totalPages > 1"></custom-pagination>
            </div>
            <div class="pl-2 w-1/3 right-content" style="min-width: 300px">
                <vx-card class="w-full no-shadow text-black">
                    <div class="p-2">
                        <h5 class="text-uppercase font-bold mb-1">Batch Close Preview</h5>
                        <div v-if="activeItem">
                            <p class="text-sm mb-2">Date: {{ activeItem.display_date_time }}</p>
                            <!-- <div class="flex align-center my-2" style="visibility: hidden; opacity: 0">
                                <img src="../../assets/images/printer-img.png" class="mr-2" />
                                <p class="text-primary text-sm">Print</p>
                            </div> -->
                            <div class="dotted-line"></div>

                            <div class="hidden-con" :class="{ 'has-service-fee': batchDetail.summary && batchDetail.summary.service_fee }">
                                <div class="w-full h-full overflow-auto">
                                    <div class="py-2" v-if="batchDetail.batches && batchDetail.batches.length > 0">
                                        <div class="flex py-05" v-for="(item, index) in batchDetail.batches" :key="index">
                                            <div class="w-1/3">{{ item.order_id }}</div>
                                            <div class="w-5/12 staff-name">{{ item.customer_name }}</div>
                                            <div class="w-1/4 text-right">${{ formatAmountNum(item.subtotal) }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="dotted-line"></div>
                            <div v-if="batchDetail.summary">
                                <div class="py-2">
                                    <div class="flex py-05">
                                        <div class="w-1/2">Card</div>
                                        <div class="w-1/2 text-right">${{ formatAmountNum(batchDetail.summary.card_amount) }}</div>
                                    </div>
                                    <div class="flex py-05">
                                        <div class="w-1/2">Cash</div>
                                        <div class="w-1/2 text-right">${{ formatAmountNum(batchDetail.summary.cash_amount) }}</div>
                                    </div>
                                    <div class="flex py-05">
                                        <div class="w-1/2">Check</div>
                                        <div class="w-1/2 text-right">${{ formatAmountNum(batchDetail.summary.check_amount) }}</div>
                                    </div>
                                    <div class="flex py-05">
                                        <div class="w-1/2">Giftcard</div>
                                        <div class="w-1/2 text-right">${{ formatAmountNum(batchDetail.summary.giftcard_amount) }}</div>
                                    </div>
                                    <div class="flex py-05">
                                        <div class="w-1/2">ACH</div>
                                        <div class="w-1/2 text-right">${{ formatAmountNum(batchDetail.summary.ach_amount) }}</div>
                                    </div>
                                    <div class="flex py-05">
                                        <div class="w-1/2">Change</div>
                                        <div class="w-1/2 text-right">${{ formatAmountNum(batchDetail.summary.change) }}</div>
                                    </div>
                                </div>
                                <div class="dotted-line"></div>
                                <div class="py-2">
                                    <div class="flex py-05">
                                        <div class="w-1/2">Sub-total:</div>
                                        <div class="w-1/2 text-right">${{ formatAmountNum(batchDetail.summary.subtotal) }}</div>
                                    </div>
                                    <div class="flex py-05">
                                        <div class="w-1/2">Tax:</div>
                                        <div class="w-1/2 text-right">${{ formatAmountNum(batchDetail.summary.tax) }}</div>
                                    </div>
                                    <div class="flex py-05" v-if="batchDetail.summary.service_fee">
                                        <div class="w-1/2">Service fee:</div>
                                        <div class="w-1/2 text-right">${{ formatAmountNum(batchDetail.summary.service_fee) }}</div>
                                    </div>
                                    <div class="flex py-05">
                                        <div class="w-1/2">Total tip:</div>
                                        <div class="w-1/2 text-right">${{ formatAmountNum(batchDetail.summary.tip) }}</div>
                                    </div>
                                    <div class="flex py-05">
                                        <div class="w-1/2">Cash Discount:</div>
                                        <div class="w-1/2 text-right">${{ formatAmountNum(batchDetail.summary.cash_discount) }}</div>
                                    </div>
                                    <div class="flex py-05" v-if="batchDetail.summary.discount_item || batchDetail.summary.discount_item === 0">
                                        <div class="w-1/2">Total Discount Item:</div>
                                        <div class="w-1/2 text-right">${{ formatAmountNum(batchDetail.summary.discount_item) }}</div>
                                    </div>
                                    <div class="flex py-05">
                                        <div class="w-1/2">Total Discount:</div>
                                        <div class="w-1/2 text-right">${{ formatAmountNum(batchDetail.summary.discount) }}</div>
                                    </div>
                                    <div class="flex py-05">
                                        <div class="w-1/2">Total Redeem:</div>
                                        <div class="w-1/2 text-right">${{ formatAmountNum(batchDetail.summary.redeem) }}</div>
                                    </div>
                                </div>

                                <div class="solid-line"></div>

                                <div class="flex align-center justify-between mt-4 total-income">
                                    <p class="text-primary">TOTAL INCOME</p>
                                    <!-- <p class="text-primary">${{ formatAmountNum(batchDetail.summary.income + batchDetail.summary.tip + batchDetail.summary.tax - batchDetail.summary.cash_discount) }}</p> -->
                                    <p class="text-primary">${{ formatAmountNum(batchDetail.summary.total) }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="text-sm no-data-con" v-else>
                            No Selected Data
                        </div>
                    </div>
                </vx-card>
            </div>
        </div>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment';
import { formatDateString } from '../../helper/datetimeHelper';
export default {
    components: { DatePicker },
    data() {
        let date_format_string = formatDateString();
        return {
            date_filter: [new Date(), new Date()],
            currentPage: 1,
            itemsPerPage: 1000,
            totalPages: 1,
            isOpenLoading: false,
            date_format_string,
            activeItem: null
        }
    },
    methods: {
        openLoadingInDiv(){
            this.$vs.loading({
                container: '#app',
                scale: 0.8
            })
            if (this.loadTime) {
                clearTimeout(this.loadTime);
                this.loadTime = null;
            }
            this.isOpenLoading = true;
            this.loadTime = setTimeout( ()=> {
                if(this.isOpenLoading) {
                    this.closeLoading();
                    this.$vs.dialog({
                        color: 'danger',
                        title: 'Notification',
                        text: 'Get Data Failed',
                        acceptText: 'OK'
                    })
                }
            }, 10000);
        },
        closeLoading() {
            this.$vs.loading.close('#app > .con-vs-loading');
            this.isOpenLoading = false;
        },
        formatAmountNum(amount) {
            if(amount) {
                // if(parseFloat(amount) > 1000) {
                //     return (parseFloat(amount / 1000).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')) + 'k';
                // }
                return parseFloat(amount).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
            }
            return '0.00';
        },
        setActiveItem(item = null) {
            let data = this.$store.getters["goPos/batchHistory"];
            this.activeItem = null;
            if(item) {
                this.activeItem = item;
            } else {
                if(data && data.length > 0) {
                    this.activeItem = data[0];
                }
            }

            this.getBatchDetail();
        },
        getData() {
            let obj = {
                start_date: moment(this.date_filter[0]).format('YYYY-MM-DD'),
                end_date: moment(this.date_filter[1]).format('YYYY-MM-DD')
            }

            if(!this.isOpenLoading) {
                this.openLoadingInDiv();
            }

            this.$store.dispatch("goPos/GET_BATCH_HISTORY", obj).then(() => {
                this.setActiveItem();
                this.closeLoading();
                // console.log(this.batchHistory);
            }).catch((err) => {
                console.log('Error: ', err);
            })
        },
        getBatchDetail() {
            if(this.activeItem) {
                let obj = {
                    date: this.activeItem.date
                }

                if(!this.isOpenLoading) {
                    this.openLoadingInDiv();
                }

                this.$store.dispatch("goPos/GET_BATCH_DETAIL", obj).then(() => {
                    this.closeLoading();
                    // console.log(this.batchDetail);
                }).catch((err) => {
                    console.log('Error: ', err);
                })
            }
        }
    },
    computed: {
        batchHistory() {
            // console.log(this.$store.getters["goPos/batchHistory"]);
            return this.$store.getters["goPos/batchHistory"];
        },
        batchDetail() {
            return this.$store.getters["goPos/batchDetail"];
        }
    },
    created() {
        this.getData();
    }
}
</script>